import { AuditStateQuestion } from '@safeguardproperties/corescript-react-npm/dist/types';

const disableKeepExisting = (question: AuditStateQuestion): boolean => {
  const { AuditCurrent, Type, Answers } = question;

  // Return true if AuditCurrent is undefined or empty
  if (!AuditCurrent?.length) {
    return true;
  }

  const isValueInvalid = (value: string) =>
    !Answers?.some(
      (answer) => answer?.TextKey.toLanguagePack() === value?.toLanguagePack()
    );

  // Handle based on question type
  switch (Type) {
    case 'Date': {
      return Number.isNaN(Date.parse(AuditCurrent[0]));
    }

    case 'Numeric':
    case 'Currency': {
      return Number.isNaN(Number(AuditCurrent[0]));
    }

    case 'SingleSelect': {
      return AuditCurrent?.length !== 1 || isValueInvalid(AuditCurrent[0]);
    }

    case 'MultiSelect': {
      return AuditCurrent?.some((auditItem) => isValueInvalid(auditItem));
    }

    default: {
      // Allow keeping existing for other types
      return false;
    }
  }
};

export default disableKeepExisting;
